import * as React from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { ABILITIES } from 'modules/reports/lib/Constants'
import { hasAbility } from 'modules/reports/lib/fieldHelper'
import type { AbilityType } from 'modules/reports/store/models/types'

import Aggregation from './Types/Aggregation'
import Filtering from './Types/Filtering'
import Grouping from './Types/Grouping'
import Ordering from './Types/Ordering'

type AnyComponent = React.ComponentType<any> | string
interface Props {
  fieldType: FieldType
  types: AbilityType[]
  variables: any[]
}

const COMPONENTS = {
  aggregation: Aggregation,
  ordering: Ordering,
  grouping: Grouping,
  filtering: Filtering,
} as const

type ComponentType = (typeof COMPONENTS)[keyof typeof COMPONENTS]

const Options = ({ fieldType, types, variables }: Props) => {
  const { field, form } = fieldType
  const hasFiltering = types.includes(ABILITIES.filtering)
  const opened = hasFiltering && !form.isCompleted
  const [open, setOpen] = React.useState(opened)
  const [disableOutsideClick, setDisableOutsideClick] = React.useState(false)
  let components: ComponentType[] = [COMPONENTS[ABILITIES.filtering]]

  if (!hasFiltering) {
    components = types.reduce((filteredArr: ComponentType[], type: AbilityType) => {
      if (field && hasAbility(field, type)) filteredArr.push(COMPONENTS[type])

      return filteredArr
    }, [])
  }

  if (!components.length) return null

  return (
    <Popover
      overflowContent
      attachment="middle left"
      size="big"
      toggle={(v: boolean) => () => setOpen(v)}
      open={open}
      disableOutsideClick={disableOutsideClick}
    >
      <Box cursor="pointer" alignItems="center">
        <Icon.Medium icon="pencil" />
      </Box>
      <Box padding="s24" gap="s12">
        {components.map((Component: AnyComponent, index: number) => (
          <Component
            key={index}
            fieldType={fieldType}
            onClose={() => setOpen(false)}
            onToggleNestedPopover={setDisableOutsideClick}
            variables={variables}
          />
        ))}
      </Box>
    </Popover>
  )
}

export default Options
